import { Helmet } from 'react-helmet-async';
import { useLocales } from 'src/locales';
import BusinessOverview from 'src/sections/overview/dashboards/views/businessOverview';

// ----------------------------------------------------------------------

export default function Home() {
  const { t } = useLocales()
  return (
    <>
      <Helmet>
        <title>{t('businessOverview')}</title>
      </Helmet>

      <BusinessOverview />
    </>
  );
}
